import {Injectable} from '@angular/core';
import {NgbTimeAdapter, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class HHMMTimeStringAdapter extends NgbTimeAdapter<string> {

  fromModel(value: string): NgbTimeStruct | null {
    if (!value) {
      return null;
    }
    const split = value.split(':');
    const hour = split.length > 0 ? parseInt(split[0], 10) : 0;
    const minute = split.length > 1 ? parseInt(split[1], 10) : 0;
    const second = split.length > 2 ? parseInt(split[2], 10) : 0;
    return {
      hour,
      minute,
      second
    };
  }

  toModel(time: NgbTimeStruct): string | null {
    if (!time) {
      return null;
    }
    // return `${this.pad(time.hour)}:${this.pad(time.minute)}:${this.pad(time.second)}`;
    return `${this.pad(time.hour)}:${this.pad(time.minute)}`;
  }

  private pad(i: number): string {
    return i < 10 ? `0${i}` : `${i}`;
  }
}
